<template>
  <section class="section full-height">
    <admin-section-header icon="television" title="Ecobanka TV" />
    <div class="columns">
      <div class="column is-three-quarters">
        <iframe
          width="100%"
          style="height: 50%;"
          src="https://www.youtube.com/embed/videoseries?list=PL3DOb74zZ2pOS2wc4GdEkL1c7fW3E0KTz"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          class="tile is-child"
        ></iframe>
      </div>
      <div class="column is-one-quarter twitter">
        <TwitterFeed profile="bancomundial" />
      </div>
    </div>
  </section>
</template>

<script>
import AdminSectionHeader from '@/components/admin/dasboard/AdminSectionHeader.vue'
import TwitterFeed from '@/components/admin/dasboard/TwitterFeed.vue'
import DashboardBannerTile from '@/components/admin/dasboard/DashboardBannerTile.vue'
export default {
  name: 'EcobankaTV',
  components: { AdminSectionHeader, TwitterFeed, DashboardBannerTile },
  computed: {},
  data() {
    return {}
  },
  mounted() {
    this.$store.commit('layout/SUB_PAGE', {
      stack: ['Admin', 'EcobankaTV'],
      title: 'EcobankaTV'
    })
  }
}
</script>

<style scoped>
iframe {
  height: 100%;
  width: 100%;
}
</style>
